module.exports = fox._r("flash/viewer_restyle.swf", __webpack_public_path__ + "_/_/_/_/common/liveshow/flash/viewer_restyle.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/flash/viewer_restyle.swf
// module id = 115
// module chunks = 4